/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_All_ButtonInputs */



/**
* | output |
* | --- |
* | "All" |
*
* @param {Spellcheck_All_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_all_button = /** @type {((inputs?: Spellcheck_All_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_All_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tout")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Все")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("全部")
	if (locale === "ja") return /** @type {LocalizedString} */ ("全て")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Todos")
	return /** @type {LocalizedString} */ ("All")
});